// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__wTXtg","navbarScrollCustom":"carroFicha_navbarScrollCustom__J9W5T","rectangle":"carroFicha_rectangle__Z73RB"};